import { callGetApi, callPostApi } from "./api";

export async function getTimesheetSignOff() {
      try {
            const response = await callGetApi({ url: "timesheet-attestations" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function signTimesheet(data) {
      try {
            const response = await callPostApi({ url: "timesheet-attestations", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
